module.exports = __webpack_public_path__ + "static/media/ETC.b9d6e70b.svg";